(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(20158);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IndexContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/people_search.svg
/* harmony default export */ var people_search = ({"src":"/_next/static/media/people_search.08543e38.svg","height":844,"width":1114});
;// CONCATENATED MODULE: ./public/images/messages.svg
/* harmony default export */ var messages = ({"src":"/_next/static/media/messages.c37c85ea.svg","height":780,"width":664});
;// CONCATENATED MODULE: ./public/images/learning.svg
/* harmony default export */ var learning = ({"src":"/_next/static/media/learning.98d8243f.svg","height":753,"width":1077});
;// CONCATENATED MODULE: ./public/images/pay_online.svg
/* harmony default export */ var pay_online = ({"src":"/_next/static/media/pay_online.f71440c4.svg","height":535,"width":888});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/IndexContent.js









function IndexContent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
            xs: 12,
            md: 8,
            className: "mx-md-auto p-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-5 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Find a Great Tutor With a Few Simple Clicks!"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4 text-center order-md-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: people_search,
                                width: 300,
                                height: 200,
                                alt: "Search tutors",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    children: [
                                        "Browse our directory of",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "text-success",
                                            children: "qualified"
                                        }),
                                        " tutors"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Simply search for a subject, choose your level and enter your post code above to get started"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: messages,
                                width: 300,
                                height: 200,
                                alt: "Messaging",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "text-success",
                                            children: "Message unlimited tutors"
                                        }),
                                        " ",
                                        "for free"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Send as many messages as you want so you can be sure you find the right fit"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4 text-center order-md-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: learning,
                                width: 300,
                                height: 200,
                                alt: "Easy learning",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    children: [
                                        "Start ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "text-success",
                                            children: "learning!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Our",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/online-tutoring",
                                            passHref: true,
                                            children: "online tutors"
                                        }),
                                        " ",
                                        "offer one-to-one online lessons"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: pay_online,
                                width: 300,
                                height: 200,
                                alt: "Straightforward billing online",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "text-success",
                                            children: "Straightforward billing"
                                        }),
                                        " ",
                                        "so the focus stays on learning"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Convenient, automated billing means you don't have to worry about paying tutors with cash"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 20768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LandingPageTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/LandingPageTile.module.scss
var LandingPageTile_module = __webpack_require__(37422);
var LandingPageTile_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageTile_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/default-tile-cover.png
/* harmony default export */ var default_tile_cover = ({"src":"/_next/static/media/default-tile-cover.80dc6840.png","height":266,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAXVBMVEWsWGS/z8bNzM+UeY6VYVrQooaTkJHItpm4bnO2ZFmNa3LAg42mY3mwaG3MnpTBc3+8XG/RdXrSim+/rKzTm2CdhIeMgX+qtbCuwLvYqJOwppTQva3erlyZpY7PxJnpbCRhAAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVR4nGOQYGRkkpZjZ2dgk5WSlBFh5WNgExNnFRLk52ZgFmUS5hBg4GHgYmHh5OTlYAAAMmgB/B686NgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/LandingPageTile.js





const LandingPageTile = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { onClick , href , page  } = param;
    const imageUrl = page.thumbnail.url || default_tile_cover.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((LandingPageTile_module_default()).imageContainer, " mb-2"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: href,
                    onClick: onClick,
                    ref: ref,
                    className: (LandingPageTile_module_default()).imageLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageUrl,
                        className: (LandingPageTile_module_default()).image,
                        alt: page.header1,
                        fill: true,
                        sizes: "100vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                onClick: onClick,
                ref: ref,
                className: "d-block text-dark text-center text-decoration-none",
                children: page.linkTitle
            })
        ]
    });
});
LandingPageTile.displayName = "LandingPageTile";
/* harmony default export */ var components_LandingPageTile = (LandingPageTile);


/***/ }),

/***/ 15666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopularSubjectsHero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _footer_data_preval__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43397);
/* harmony import */ var _footer_data_preval__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_footer_data_preval__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var _LandingPageTile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20768);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);







function PopularSubjectsHero() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 text-center",
                    children: "Popular Subjects"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: _footer_data_preval__WEBPACK_IMPORTED_MODULE_2___default().subjects.map((subject)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            md: 3,
                            xs: 12,
                            className: "mb-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/tutoring/".concat(subject.slug),
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageTile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    page: subject
                                })
                            })
                        }, subject.id))
                })
            ]
        })
    });
}


/***/ }),

/***/ 20158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./components/SignUpHero.js







function SignUpHero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-5 text-center",
                children: "Get Started With Tutorspot Today"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        md: 5,
                        className: "offset-md-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 bg-white rounded mb-4 mb-md-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                            className: "d-block mb-3 text-uppercase text-muted text-spaced font-weight-bold",
                                            children: "Become a"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Student"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Learn from the finest",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/online-tutoring",
                                            passHref: true,
                                            children: "online tutors"
                                        }),
                                        " ",
                                        "in the UK"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Easily connect with the perfect tutor for your needs"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Convenient and automated payment"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Our Concierge Service supports you at every step"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/request-tutor",
                                        passHref: true,
                                        className: "btn btn-info",
                                        children: "Request a Tutor"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        md: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 bg-info text-white rounded h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                            className: "d-block mb-3 text-uppercase text-spaced font-weight-bold",
                                            children: "Become a"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Tutor"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Get discovered by students across the UK"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Build your business or simple tutor a few students"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Get paid quickly and conveniently"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faCheckCircle */.f8k,
                                            className: "me-2"
                                        }),
                                        "Guidance and support from the Tutorspot team"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/tutor",
                                        passHref: true,
                                        className: "btn btn-light",
                                        children: "Request a Tutor"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/PopularSubjectsHero.js
var PopularSubjectsHero = __webpack_require__(15666);
// EXTERNAL MODULE: ./components/IndexHero.module.scss
var IndexHero_module = __webpack_require__(19166);
var IndexHero_module_default = /*#__PURE__*/__webpack_require__.n(IndexHero_module);
// EXTERNAL MODULE: ./components/HeroSearch.js + 3 modules
var HeroSearch = __webpack_require__(56665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/IndexHero.js








function IndexHero() {
    const videoRef = (0,react.useRef)();
    const setPlayback = ()=>{
        videoRef.current.playbackRate = 0.6;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (IndexHero_module_default()).heroContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IndexHero_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: videoRef,
                onCanPlay: setPlayback,
                playsInline: true,
                autoPlay: true,
                muted: true,
                loop: true,
                className: (IndexHero_module_default()).coverVideo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: "/videos/index-bg-video.mp4",
                    type: "video/mp4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "pt-lg-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            lg: 6,
                            md: 8,
                            className: "pt-5 pb-lg-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "loud-header text-white pb-2",
                                children: "Find Qualified Online and Local Tutors"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 12,
                            className: "pt-2 pt-lg-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSearch/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-primary p-4 text-white text-center rounded mb-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                        className: "mb-0",
                                        children: [
                                            "Tutorspot can help you excel throughout the school year.",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/online-tutoring",
                                                passHref: true,
                                                className: "text-white",
                                                target: "_blank",
                                                children: "Learn about our online tutoring."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/IndexContent.js + 4 modules
var IndexContent = __webpack_require__(79059);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 4 modules
var Accordion = __webpack_require__(47806);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js
var AccordionButton = __webpack_require__(93621);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js
var AccordionContext = __webpack_require__(88792);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/undraw_active_support_re_b7sj.svg
/* harmony default export */ var undraw_active_support_re_b7sj = ({"src":"/_next/static/media/undraw_active_support_re_b7sj.eae2b877.svg","height":551,"width":652});
;// CONCATENATED MODULE: ./public/images/undraw_booked_re_vtod.svg
/* harmony default export */ var undraw_booked_re_vtod = ({"src":"/_next/static/media/undraw_booked_re_vtod.4fe4b2a2.svg","height":589,"width":767});
;// CONCATENATED MODULE: ./public/images/undraw_collaborators_re_hont.svg
/* harmony default export */ var undraw_collaborators_re_hont = ({"src":"/_next/static/media/undraw_collaborators_re_hont.6cb14b6e.svg","height":624,"width":989});
;// CONCATENATED MODULE: ./public/images/undraw_education_f8ru.svg
/* harmony default export */ var undraw_education_f8ru = ({"src":"/_next/static/media/undraw_education_f8ru.e8b1dbe1.svg","height":539,"width":744});
;// CONCATENATED MODULE: ./components/ValuePropositionAccordion.js












// const GlobalAccordionContext = createContext({
//   globalCurrentEventKey: "0",
//   updateGlobalCurrentEventKey: () => {}
// })
function ContextAwareToggle(param) {
    let { children , eventKey , setActive , callback  } = param;
    const { activeEventKey  } = (0,react.useContext)(AccordionContext/* default */.Z);
    const decoratedOnClick = (0,AccordionButton/* useAccordionButton */.k)(eventKey, ()=>{
        callback && callback(eventKey);
        setActive(eventKey);
    });
    const isCurrentEventKey = activeEventKey === eventKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionButton/* default */.Z, {
        className: "bg-transparent",
        onClick: decoratedOnClick,
        children: children
    });
}
function ValuePropositionAccordion() {
    const [activeKey, setActiveKey] = (0,react.useState)("0");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                    defaultActiveKey: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextAwareToggle, {
                                        eventKey: "0",
                                        setActive: setActiveKey,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0",
                                            children: "Expert tutors, hand-picked by us"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                                    eventKey: "0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: "We select only the best tutors so you don't have to worry. Our high standard of excellence means we accept only expert, qualified tutors."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextAwareToggle, {
                                        eventKey: "1",
                                        setActive: setActiveKey,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0",
                                            children: "Hands-on service"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                                    eventKey: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: "We act as a concierge throughout your tutoring journey. From selecting the perfect tutor through to ensuring lessons are scheduled correctly, we're here to help."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextAwareToggle, {
                                        eventKey: "2",
                                        setActive: setActiveKey,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0",
                                            children: "Our tutors go above and beyond"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                                    eventKey: "2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: "Tutorspot tutors care about you, and most importantly they care about your outcome. Our tutors love what they do and are dedicated to ensuring they help you in every way possible."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextAwareToggle, {
                                        eventKey: "3",
                                        setActive: setActiveKey,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0",
                                            children: "Tutoring when you need it"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                                    eventKey: "3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: "Tutors are available during the day or in the evening, weekdays and weekends. You have a busy schedule and we're here to make sure tutoring fits in perfectly."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-4",
                    children: [
                        activeKey === "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: undraw_education_f8ru,
                            style: {
                                maxWidth: "100%",
                                height: "auto"
                            }
                        }),
                        activeKey === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: undraw_active_support_re_b7sj,
                            style: {
                                maxWidth: "100%",
                                height: "auto"
                            }
                        }),
                        activeKey === "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: undraw_collaborators_re_hont,
                            style: {
                                maxWidth: "100%",
                                height: "auto"
                            }
                        }),
                        activeKey === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: undraw_booked_re_vtod,
                            style: {
                                maxWidth: "100%",
                                height: "auto"
                            }
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Carousel.js + 4 modules
var Carousel = __webpack_require__(70130);
;// CONCATENATED MODULE: ./components/TestimonialsCarousel.js






const testimonials = [
    {
        quote: "Tutorspot has a lot of tutors to choose from and the team has been very helpful in finding the right tutors based on the needs. If something doesn't work out, they quickly send more profiles of tutors and give recommendations based on the feedback that they received.",
        name: "Meena M"
    },
    {
        quote: "Both tutors have been flexible and efficient and Tutorspot has always been extremely responsive, providing the best guidance on suitable tutors. I cannot recommend Tutorspot highly enough.",
        name: "Sarah A"
    },
    {
        quote: " I would definitely recommend Tutorspot to my friends and family, they helped match my daughter to an excellent tutor and are always willing to support with any queries.",
        name: "Fizzah R"
    }
];
function TestimonialsCarousel() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-5 text-center",
                children: "Students Love Tutorspot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xs: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                        controls: false,
                        children: testimonials.map((testimonial)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default.Item */.Z.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "lead",
                                            children: testimonial.quote
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-center",
                                            children: [
                                                "-",
                                                testimonial.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center",
                                            children: [
                                                ...Array(5)
                                            ].map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons_index_es/* faStar */.Tab,
                                                    className: "text-gold"
                                                }, i))
                                        })
                                    ]
                                })
                            }, testimonial.name))
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.js








function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Tutorspot | Online tutoring | Tutors near you"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Generated by create next app"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "The Tutorspot Difference"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuePropositionAccordion, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsCarousel, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexContent/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpHero, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white mt-5 mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSubjectsHero/* default */.Z, {})
            })
        ]
    });
}


/***/ }),

/***/ 19166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"IndexHero_heroContainer__CDCiP","coverVideo":"IndexHero_coverVideo__n_w5n","overlay":"IndexHero_overlay__O1C3C"};

/***/ }),

/***/ 37422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"LandingPageTile_imageContainer__vIAv6","imageLink":"LandingPageTile_imageLink__qYp7c","image":"LandingPageTile_image__9cmfi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,734,425,665,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);